import {Trans} from '@lingui/macro';
import {Divider} from '@material-ui/core';
import React from 'react';
import ProfGralGrid from '../component/ProfGralGrid';
const profGralPage = () => {
  return (
    <>
      <h2 className={'TitleGrid'}>
        <Trans>Profile-General</Trans>
      </h2>
      <Divider variant="middle" style={{marginBottom: 10}} />
      <ProfGralGrid />
    </>
  );
};

export default profGralPage;
